import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CuiPanel } from '../panel';

export class CuiInteractiveExample extends Component {
  componentDidMount() {
    this.jsNode = document.createElement('script');
    this.jsNode.type = 'text/javascript';
    this.jsNode.innerHTML = this.props.js;
    this.jsElement.appendChild(this.jsNode);
  }

  jsRef = node => {
    this.jsElement = node;
  };

  render() {
    const { className, html, js, ...rest } = this.props;
    const classes = classNames('cuiInteractiveExample', className);
    return (
      <CuiPanel className={classes} {...rest}>
        <div
          className="cuiInteractiveExample__content"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: html }}
        />

        <span className="cuiInteractiveExample__js" ref={this.jsRef} />
      </CuiPanel>
    );
  }
}

CuiInteractiveExample.propTypes = {
  className: PropTypes.string,
  js: PropTypes.string,
  html: PropTypes.string,
};

CuiInteractiveExample.defaultProps = {
  className: undefined,
  js: '',
  html: '',
};



// WEBPACK FOOTER //
// ./ui/components/interactiveExample/InteractiveExample.js